import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TextboxQuestion } from '../../shared/models/textbox-question';
import { Question } from 'app/shared/models/question';

@Component({
  selector: 'dac-question-textbox',
  templateUrl: './question-textbox.component.html',
  styleUrls: ['./question-textbox.component.css']
})
export class QuestionTextboxComponent implements OnInit {

  @Input ("question") question:TextboxQuestion;
  @Output() answered:EventEmitter<Question>;
  constructor() { 
    this.answered = new EventEmitter<Question>(); 
  }

  ngOnInit() {
  }

  get Question() {
    return this.question;
  }

  public handleChange(text:string) {
    this.question.answer = text;
    this.answered.emit(this.question);
  }

}



// WEBPACK FOOTER //
// ./src/app/assessments/question-textbox/question-textbox.component.ts